<template>
  <div class="header-logo"
       :class="logoClasses">
    <div @click="onLogoClick">
      <img v-if="$mq === 'mobile'"
           src="/logo-white-mobile.svg"
           class="logo-mobile">

      <img v-else-if="$mq === 'small'"
           src="/logo-white-mobile.svg"
           class="logo-small">

      <img v-else
           src="/logo-white.svg"
           class="logo">
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      logoClasses() {
        return {
          'header-logo-mobile': this.$mq === 'mobile'
        }
      }
    },

    methods: {
      onLogoClick() {
        if (this.$mq === 'mobile') {
          this.$router.push({ name: 'feed' })

          return
        }

        this.$router.push({ name: 'overview' })

        return
      }
    }
  }
</script>


<style lang="scss" scoped>
  .header-logo {
    margin-left: 50px;

    .logo {
      cursor: pointer;
    }
  }

  .header-logo-mobile {
    margin-left: 8px;
  }

  .logo-mobile {
    width: 32px;
    cursor: pointer;
  }

  .logo-small {
    width: 52px;
    cursor: pointer;
  }
</style>
